import React from "react";
import { Label, Grid, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { StoreContext } from "../../contexts/StoreContext";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";

const ITEMS_VIEW_LIMIT = 3;

export class CubeDifferencesItem extends React.Component {
  static contextType = StoreContext;

  state = {
    showAll: false,
  };

  toggleShowAll = () => {
    this.setState((prevState) => ({
      showAll: !prevState.showAll,
    }));
  };

  renderChildItems = (childItems, isParent = true) => {
    return (
      <ul>
        {childItems
          .slice(0, this.state.showAll ? childItems.length : ITEMS_VIEW_LIMIT)
          .map((item, index) => {
            if (!item.object) {
              return null;
            }
            if (isParent && item.object.type === "Variable") {
              return null;
            }

            return (
              <li
                key={index}
                style={{
                  backgroundColor:
                    item.changeType === "ADDED"
                      ? "#d4edda"
                      : item.changeType === "UPDATED"
                      ? "#fff3cd"
                      : item.changeType === "DELETED"
                      ? "#f8d7da"
                      : "inherit",
                  padding: "10px",
                  marginBottom: "5px",
                  borderRadius: "5px",
                }}
              >
                <p>
                  <Link to={`/view/${item.object.type}/${item.object.tid}`}>
                    {`${item.object.name || "[No name]"}`}
                  </Link>
                  {` (${item.object.code || "[No code]"}) `}
                  <Label className="object-type" bsStyle="success">
                    {item.object.type}
                  </Label>
                  <Label
                    bsStyle={
                      item.changeType === "ADDED"
                        ? "primary"
                        : item.changeType === "UPDATED"
                        ? "warning"
                        : "danger"
                    }
                  >
                    {item.changeType}
                  </Label>
                  {item.object.maintenanceAgencyId && (
                    <MaintenanceAgencyLabel
                      maintenanceAgencyId={item.object.maintenanceAgencyId}
                    ></MaintenanceAgencyLabel>
                  )}
                </p>
                {item.object.description && (
                  <p style={{ fontSize: "0.9em", marginTop: "5px" }}>
                    {item.object.description}
                  </p>
                )}
                {item.childResultItems && item.childResultItems.length > 0 && (
                  <div
                    style={{
                      marginLeft: "20px",
                      borderLeft: "2px solid #ccc",
                      paddingLeft: "10px",
                    }}
                  >
                    {this.renderChildItems(item.childResultItems, false)}
                  </div>
                )}
              </li>
            );
          })}
        {childItems.length > ITEMS_VIEW_LIMIT && (
          <button
            className="btn btn-link show-all-toggle"
            onClick={this.toggleShowAll}
          >
            {this.state.showAll
              ? "Show less"
              : `Show all (${childItems.length} items)`}
          </button>
        )}
      </ul>
    );
  };

  renderVariables = (childItems) => {
    return (
      <ul>
        {childItems
          .slice(0, this.state.showAll ? childItems.length : ITEMS_VIEW_LIMIT)
          .map(
            (item, index) =>
              item.object &&
              item.object.type === "Variable" && (
                <li
                  key={index}
                  style={{
                    backgroundColor:
                      item.changeType === "ADDED"
                        ? "#d4edda"
                        : item.changeType === "UPDATED"
                        ? "#fff3cd"
                        : item.changeType === "DELETED"
                        ? "#f8d7da"
                        : "inherit",
                    padding: "10px",
                    marginBottom: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <p>
                    <Link to={`/view/${item.object.type}/${item.object.tid}`}>
                      {`${item.object.name || "[No name]"}`}
                    </Link>
                    {` (${item.object.code}) `}
                    <Label className="object-type" bsStyle="success">
                      {item.object.type}
                    </Label>
                    <Label
                      bsStyle={
                        item.changeType === "ADDED"
                          ? "primary"
                          : item.changeType === "UPDATED"
                          ? "warning"
                          : "danger"
                      }
                    >
                      {item.changeType}
                    </Label>
                    {item.object.maintenanceAgencyId ? (
                      <MaintenanceAgencyLabel
                        maintenanceAgencyId={item.object.maintenanceAgencyId}
                      ></MaintenanceAgencyLabel>
                    ) : null}
                  </p>
                  {item.object.description && (
                    <p style={{ fontSize: "0.9em", marginTop: "5px" }}>
                      {item.object.description}
                    </p>
                  )}
                </li>
              )
          )}
        {childItems.length > ITEMS_VIEW_LIMIT && (
          <button
            className="btn btn-link show-all-toggle"
            onClick={this.toggleShowAll}
          >
            {this.state.showAll
              ? "Show less"
              : `Show all (${childItems.length} items)`}
          </button>
        )}
      </ul>
    );
  };

  render() {
    const { diffItems } = this.props;
    if (!diffItems || !diffItems.length) {
      return null;
    }

    return (
      <Grid className="cube-differences-item" fluid={true}>
        <Row style={{ borderBottom: "1px solid #ddd", marginBottom: "10px" }}>
          {diffItems.map((diff, index) => (
            <Col xs={6} key={index} className="mb-3">
              {diff.childResultItems && diff.childResultItems.length > 0 && (
                <div className="child-items">
                  {this.renderVariables(diff.childResultItems)}
                </div>
              )}
            </Col>
          ))}

          {diffItems.map((diff, index) => (
            <Col xs={6} key={index} className="mb-3">
              {diff.childResultItems && diff.childResultItems.length > 0 && (
                <div className="child-items">
                  {this.renderChildItems(diff.childResultItems)}
                </div>
              )}
            </Col>
          ))}
        </Row>
      </Grid>
    );
  }
}

export default CubeDifferencesItem;
